'use client'

import LiveryCard from '@/components/_cards/livery/livery-card'

export default function ViewLivery({ session, user }) {
  const liveries = user.liveryDesigns || []

  if (liveries.length === 0) {
    return (
      <div className="flex h-36 w-full items-center justify-center text-center text-xl text-shades-0">
        No liveries found.
      </div>
    )
  }

  return (
    <div className="grid w-full grid-cols-1 gap-5 tablet:grid-cols-3">
      {liveries.map((livery) => (
        <LiveryCard
          livery={{ ...livery, user }}
          key={livery.id}
          session={session}
        />
      ))}
    </div>
  )
}
